/* storage.js */

const PREFIXES = {
	'object': [
		data => JSON.stringify(data),
		data => JSON.parse(data),
	],
	'string': [
		data => data,
		data => data,
	],
	'number': [
		data => data.toString(),
		data => Number(data),
	],
	'boolean': [
		data => data ? '1' : '0',
		data => parseInt(data) ? true : false,
	],
};


/* test */
export function test() {
	try {
		localStorage.setItem('___test', 'test');
		localStorage.removeItem('___test');
	}
	catch(error) {
		return false;
	}
	return true;
}


/* set */
export function set(key, data) {
	const t = typeof data;
	if (PREFIXES[t]) {
		localStorage.setItem('___' + key, t + '|' + PREFIXES[t][0](data))
	}
}


/* get */
export function get(key) {
	const data = localStorage.getItem('___' + key);
	if (typeof data === 'string') {
		const result = /^(object|string|number|boolean)\|(.*)/.exec(data);
		if (result && result[1] && PREFIXES[result[1]])
			return PREFIXES[result[1]][1](result[2]);
	}
	return undefined;
}


/* clear */
export function clear() {
	localStorage.clear();
}
